module.exports = __webpack_public_path__ + "img/picto-tab-spiritualite.7393e2c0.svg";